import React from "react";
import "../assets/styles/components/Error.scss";
import noVideoImage from "../assets/static/images/no-video.jpg";

const NoVideo = () => (
  <div className="novideo">
    <img className="novideo-img" src={noVideoImage} alt="No Video" />{" "}
    <p className="novideo-text">Sorry, no video trailer.</p>
  </div>
);

export default NoVideo;
